import styles from "../../Styles/about.module.scss";
import markrothko from '../../Assets/mark-rothko.webp'

function About() {
  return (
    <div className={styles.aboutPopup}>
      <img className={styles.img} width={250} src={markrothko} alt="Mark Rothko No 61 Painting" />
      <div className={styles.content}>
        <p>No. 61 (Rust and Blue) is a 1953 painting by the abstract expressionist artist Mark Rothko.</p>
        <br/>
        <p>No. 61  was first exhibited at the Museum of Modern Art, New York in 1961 but is now in the collection of the Museum of Contemporary Art, Los Angeles. </p>
        <br/>
        <p>Rothko described this painting as "inner light".</p>
      </div>
    </div>
  );
}

export default About;